import React from "react";

/**
 * App-level error boundary so a crash in any route shows a friendly RTL
 * message + diagnostic instead of the dreaded white screen.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  reset = () => {
    this.setState({ error: null });
    if (typeof window !== "undefined") window.location.href = "/";
  };

  reload = () => {
    try {
      localStorage.removeItem("access_token");
    } catch {}
    if (typeof window !== "undefined") window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;
    const msg = String(this.state.error?.message || this.state.error);
    const isProxyIssue = msg.includes("API proxy") || msg.includes("HTML");
    return (
      <div
        dir="rtl"
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          padding: "24px",
          background: "#F4F8F5",
          fontFamily: "Cairo, system-ui, sans-serif",
        }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 16,
            padding: 32,
            maxWidth: 520,
            textAlign: "center",
            boxShadow: "0 4px 24px rgba(17,122,71,0.08)",
            border: "1px solid #e6e8e6",
          }}
        >
          <div style={{ fontSize: 48, marginBottom: 8 }}>⚠️</div>
          <h2 style={{ margin: "8px 0 12px", color: "#117A47", fontSize: 22 }}>
            تعذّر تحميل التطبيق
          </h2>
          {isProxyIssue ? (
            <p style={{ color: "#666", fontSize: 14, lineHeight: 1.8 }}>
              يبدو أن خادم الواجهة الخلفية (API) لا يعمل أو أن إعداد الـ proxy
              يوجّه طلبات <code>/api/*</code> إلى الواجهة الأمامية بدلاً من
              الـ backend.
              <br />
              تحقق من ملف <code>Caddyfile</code> / <code>nginx.conf</code> على
              السيرفر وتأكد أن <code>/api/*</code> يُمرَّر إلى منفذ 8001.
            </p>
          ) : (
            <p style={{ color: "#666", fontSize: 14, lineHeight: 1.8 }}>
              حدث خطأ غير متوقع. حاول إعادة تحميل الصفحة، وإذا استمرت المشكلة
              تواصل مع الدعم الفني.
            </p>
          )}
          <pre
            style={{
              background: "#f9f9f9",
              borderRadius: 8,
              padding: 12,
              marginTop: 16,
              fontSize: 11,
              color: "#999",
              direction: "ltr",
              textAlign: "left",
              maxHeight: 140,
              overflow: "auto",
            }}
          >
            {msg}
          </pre>
          <div style={{ display: "flex", gap: 8, marginTop: 16, justifyContent: "center" }}>
            <button
              onClick={this.reload}
              style={{
                background: "#117A47",
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                borderRadius: 8,
                cursor: "pointer",
                fontFamily: "inherit",
                fontWeight: 600,
              }}
            >
              إعادة تحميل
            </button>
            <button
              onClick={this.reset}
              style={{
                background: "transparent",
                color: "#117A47",
                border: "1px solid #117A47",
                padding: "10px 20px",
                borderRadius: 8,
                cursor: "pointer",
                fontFamily: "inherit",
                fontWeight: 600,
              }}
            >
              الصفحة الرئيسية
            </button>
          </div>
        </div>
      </div>
    );
  }
}
